import React, { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { FiLinkedin } from 'react-icons/fi'
import { SiGlassdoor } from 'react-icons/si'
import CookiesModal from './CookiesModal'
import MapModal from './MapModal';



const Footer = () => {
  
    const [hovered, setHovered] = useState(false);
    const handleMouseEnter = () => {
      setHovered(true);
    };
    const handleMouseLeave = () => {
      setHovered(false);
    };
  return (
    <Container className='footer'>

      <Row className='checkUsOutContainer'>
        <Col className='footerLinkContainer cookies'>
          <h4>Check us out! </h4>
          <Row>
          <a href='https://www.linkedin.com/company/core-gaming-limited/mycompany/' target={'blank'} rel='noreferrer' className='checkUsOutIcon linkedInLink' >
            <FiLinkedin/>
          </a>
          
          <a href='https://www.glassdoor.co.uk/Overview/Working-at-Core-Gaming-EI_IE2087174.11,22.htm' target={'blank'} rel='noreferrer' className='checkUsOutIcon glassDoorLink' >
            <SiGlassdoor/>
          </a>
          </Row>

        </Col>
      </Row>


      <Row>
        <Col className='address'>
          <h4>Contact Us </h4>
          {/* <img src={coreLogo} width="150" height="auto"  className="d-inline-block align-top" alt="CORE Gaming Logo"/> */}
          <Row className='contactUsText'>CORE Gaming Ltd </Row>
          <Row className='contactUsText'>Radcliffe House 3rd Floor East</Row>
          <Row className='contactUsText'>Blenhiem Court | Lode Lane | Solihull</Row>
          <Row className='contactUsText'>West Midlands | <MapModal/> | United Kindgom</Row>
          <Row className='contactUsText'><br></br>&copy; 2026 CoreGaming - Flutter Studios - Flutter Entertainment Plc. All Rights Reserved</Row>
        </Col>
      </Row>

      <Row>
        <Col >
        <div className= {`cookiesImageContainer ${hovered? 'hovered' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleMouseLeave} >
          <Row> <CookiesModal/></Row>
        </div>
        <span className={`toolTipTextCookies ${hovered? 'complianceShow' : 'complianceHide'}`}>  Cookies </span>

        </Col>
      </Row>


    </Container>

  )
}

export default Footer